import React, {useEffect, useState} from 'react';
import { Modal } from 'react-bootstrap';
import getCommonResponse from '../actions/Common';
import { useNavigate } from "react-router-dom";
import RefreshToken from '../actions/RefreshToken';
import { trim, getStateList, getCountryNameArray } from '../Reusables/Function';
import CityStatedropdown from '../Reusables/CityStatedropdown';
import Dropdown from '../Reusables/Dropdown';
import '../../scss/popups/add_sub_brand.scss';

import closeIcon from '../../images/popups/upload/closeicon.png';


function AddSubBrand(props) {
    const {brandId, showPopup, setShowPopup, trigger, 
        setTrigger, values, setValues, setOpen, setError, type} = props;
    const navigate = useNavigate();
    const [enable, setEnable] = useState(true);
    const [countryNames, setCountryNames] = useState([]);
    const [countryLabel, setCountryLabel] = useState("Select Country");


    useEffect(() => {
        var countries = getCountryNameArray();
        var i = 1;
        var contryArray = [];
        countries.map((country) => {
            const countryObject = {id: 0, name: ''}
            countryObject.id = i;
            countryObject.name = country;

            i++;
            contryArray.push(countryObject);
        })
        setCountryNames(contryArray);
        setCountryLabel((values.country != null && values.country != "") ? values.country : "Select Country")
    }, [])

    const handleSubBrand = () => {    
        setEnable(false);
        var endpoint = "/api/brand/add";
        
        const details = {
            ParentBrand: brandId,
            Name: trim(values.name),
            Address: trim(values.address),
            ZipCode: values.zipcode === "" ? null : trim(values.zipcode),
            Country: values.country != "Select Country" ? values.country : null,
            State: values.state != "" ? values.state : null,
            City: values.city != null ? trim(values.city) : null,
        }

        if(type == 'edit') {
            endpoint = "/api/brand/update"
            details.IdBrand = values.id
        }
        
        function CallAPI(accesstoken) {
            if(accesstoken === '') {
                navigate('/login');
            }
            else {
                getCommonResponse.PostDetails(endpoint, accesstoken, details, (data) => {
                    setEnable(true);
                    if(data.status == 200) {
                        setOpen(false)
                        setTrigger(!trigger)
                        setShowPopup(false);
                    }
                    if (data.status == 400) {
                        setOpen(true)
                        setError(data.data.message);
                    } else if(data.status == 401) {
                        navigate("/login")
                    }
                });
            }
        }
        RefreshToken((accesstoken) => CallAPI(accesstoken));
    }

    const handleCancelPopup = () => {
        setShowPopup(false);
    }

    const handleInputChange = (fieldName, value) => {
        setValues({
          ...values,
          [fieldName]: value
        });
    }

    return (
        <>
            <Modal
                show={showPopup}
                onHide={handleCancelPopup} className='add-sub-brand-popup'
                centered>
                <Modal.Body className='add-sub-brand-body'>
                    <div className='close-icon'>
                        <img src={closeIcon} onClick={handleCancelPopup}/>
                    </div>
                    <div className='add-sub-brand-content'>
                        <div className='add-sub-brand-popup-header'>{`${(type == 'edit') ? "Edit Brand" : "Add Brand"}`}</div>
                        <div className='entity-sub-brand-container'>
                            {(showPopup) && 
                            <div className='add-sub-brand-container'>
                                <div className='field-container'>
                                    <div className='name-field'>
                                        <div className='label required'>Brand Name</div> 
                                        <input type="text" value={values.name} onChange={(e) => handleInputChange("name", e.target.value)}
                                        maxLength={100}/>
                                    </div>
                                    <div className='address-field'>
                                        <div className='label'>Address</div> 
                                        <input type="text" value={values.address} onChange={(e) => handleInputChange("address", e.target.value)}
                                        maxLength={100}/>
                                    </div>
                                    <div className='city-field'>
                                        <div className='label'>City</div> 
                                        <input type="text" value={values.city} onChange={(e) => handleInputChange("city", e.target.value)}
                                        maxLength={45}/>
                                    </div>
                                    <div className='state-field'>
                                        <div className='label'>State / Province</div>
                                        <div className='state-dropdown'>
                                            <CityStatedropdown selectedItem={(name) => handleInputChange("state", name)} handleLabel={(value) => handleInputChange("state", value)} list={getStateList()} label={values.state}/>
                                        </div>
                                    </div>
                                    <div className='zipcode-field'>
                                        <div className='label'>Zip / Postal Code</div> 
                                        <input type="text" value={values.zipcode} onChange={(e) => handleInputChange("zipcode", e.target.value)}
                                        maxLength={45}/>
                                    </div>
                                    <div className='country-field'>
                                        <div className='label'>Country / Region</div>
                                        {countryNames.length > 0 &&
                                        <Dropdown className="country-dropdown" label={countryLabel} selectedItem={(name, id) => handleInputChange("country", name)}
                                            handleLabel={(value) => setCountryLabel(value)} list={countryNames} enable={true}/>}
                                    </div>
                                </div>
                                <div className='buttons-container'>
                                    <div className='add-button'>
                                        <button disabled={!enable} className={enable ? 'button-enable' : 'button-disable'} onClick={handleSubBrand}>Save</button>
                                    </div>
                                    <div className='cancel-button'>
                                        <button className='button-enable' onClick={handleCancelPopup}>Cancel</button>
                                    </div>
                                </div>
                            </div>}
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
}

export default AddSubBrand;